import { FieldsEnum, FormsEnum } from 'app/shared/enums';
import {
  getQuotation,
  getQuotationIsFromRenewal,
  getSecondCoownerData,
  setDataOwnersChangedRenewal,
  setMessageVisibility,
} from 'app/services/businessFunctionHelpers';
import { DriverType } from 'app/shared/enums';
import {
  BusinessFunctionsService,
  setNoDriverLicenseFieldsVisibility,
} from 'app/services/businessFunctions.service';
import { setBirthdateAndGenderByPesel } from 'app/services/businessFunctions/helpers/setBirthdateAndGenderByPesel';
import { setFamilyNameVisibility } from 'app/services/businessFunctions/helpers/setFamilyNameVisibility';
import { isPeselValid, stringifyPesel } from 'app/services/pesel.service';
import { getMessageKeyWithSuffix } from 'app/services/validation.service';
import { checkHasDataChangedForRenewal } from 'app/services/businessFunctions/helpers/checkHasDataChangedForRenewal';

const secondCoownerDetails = {
  secondCoownerPeselChange(initialRun: boolean) {
    const { coOwners } = getQuotation();
    const isFromRenewal = getQuotationIsFromRenewal();
    const { pesel } = getSecondCoownerData();
    const previousPesel = coOwners?.[1]?.peselNumber || '';
    const isValidPesel = isPeselValid(stringifyPesel(pesel));

    if (initialRun) {
      setMessageVisibility({
        formName: FormsEnum.CalculationForm,
        key: getMessageKeyWithSuffix(
          FieldsEnum.Coowners2Pesel,
          'invalid_pesel'
        ),
        visible: false,
      });

      setMessageVisibility({
        formName: FormsEnum.CalculationForm,
        key: getMessageKeyWithSuffix(
          FieldsEnum.Coowners2Pesel,
          'too_young_owner_pesel'
        ),
        visible: false,
      });
    }

    setBirthdateAndGenderByPesel(
      initialRun,
      pesel as number,
      FormsEnum.CalculationForm,
      FieldsEnum.Coowners2BirthDate,
      FieldsEnum.Coowners2Gender
    );

    setFamilyNameVisibility(
      FieldsEnum.Coowners2FamilyName,
      FormsEnum.CalculationForm,
      stringifyPesel(pesel),
      isValidPesel
    );

    if (isFromRenewal) {
      if (checkHasDataChangedForRenewal(pesel, previousPesel)) {
        setDataOwnersChangedRenewal({
          ownerName: 'secondCoOwner',
          isChanged: true,
        });

        if (!initialRun && isValidPesel) {
          BusinessFunctionsService.setupSecondCoownerLicenseDates(initialRun);
          setNoDriverLicenseFieldsVisibility(DriverType.COOWNERS_2, initialRun);
        }
      }
    } else if (initialRun || isValidPesel) {
      BusinessFunctionsService.setupSecondCoownerLicenseDates(initialRun);
      setNoDriverLicenseFieldsVisibility(DriverType.COOWNERS_2, initialRun);
    }
  },
};
export default secondCoownerDetails;
